/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
const itemGroupIosCss = "ion-item-group{display:block}";
const itemGroupMdCss = "ion-item-group{display:block}";
const ItemGroup = /*@__PURE__*/proxyCustomElement(class ItemGroup extends HTMLElement {
  constructor(registerHost) {
    super();
    if (registerHost !== false) {
      this.__registerHost();
    }
  }
  render() {
    const mode = getIonMode(this);
    return h(Host, {
      key: 'e49dc8f99247d2431d7c6db01b6e021a0f5b1c37',
      role: "group",
      class: {
        [mode]: true,
        // Used internally for styling
        [`item-group-${mode}`]: true,
        item: true
      }
    });
  }
  static get style() {
    return {
      ios: itemGroupIosCss,
      md: itemGroupMdCss
    };
  }
}, [288, "ion-item-group"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ion-item-group"];
  components.forEach(tagName => {
    switch (tagName) {
      case "ion-item-group":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ItemGroup);
        }
        break;
    }
  });
}
const IonItemGroup = ItemGroup;
const defineCustomElement = defineCustomElement$1;
export { IonItemGroup, defineCustomElement };